import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'
import userSlice from './slice/user-slice'
import modalSlice from './slice/modal-slice'
import currentSlice from './slice/current-slice'
import subscribeSlice from './slice/subscribe-slice'
import posPaySettingsSlice from './slice/Pos-pay-settings-slice'
import mobileHelperSlice from './slice/mobile-helper-slice';
import memberTagsSlice from './slice/member-tags-slice';

const persistConfig = {
  key: 'flone',
  version: 1.1,
  storage,
}

export const rootReducer = combineReducers({
  user: userSlice,
  modal: modalSlice,
  current: currentSlice,
  subscribe: subscribeSlice,
  posPaySettings: posPaySettingsSlice,
  helper: mobileHelperSlice,
  memberTags: memberTagsSlice,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)
